var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaskGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 26"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask_group_svg__a",
  width: 60,
  height: 26,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M29.809 1v1.856"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00A68C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m44.719 5-.928 1.607m11.839 9.304-1.608.928"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E0485C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m3.988 15.911 1.607.928M14.899 5l.927 1.607"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00A68C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m37.535 2.012-1.2 4.48m14.562 3.242-3.28 3.28M58.62 23.096l-4.481 1.2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E0485C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8.723 9.734 3.28 3.28M22.084 2.012l1.2 4.48M1 23.1l4.481 1.2"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask_group_svg__a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 29.809,
  cy: 16.838,
  fill: "url(#mask_group_svg__b)",
  rx: 33,
  ry: 21,
  transform: "rotate(-180 29.809 16.838)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mask_group_svg__b",
  x1: -3.191,
  x2: 62.809,
  y1: 16.838,
  y2: 16.838,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#37B08C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.406,
  stopColor: "#74C8AF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.599,
  stopColor: "#E97B89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0485C"
})))));
export default SvgMaskGroup;